import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import CopyIcon from "@mui/icons-material/FileCopy";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MailIcon from "@mui/icons-material/MailOutline";
import PhoneIcon from "@mui/icons-material/PhoneAndroid";
import PrintIcon from "@mui/icons-material/Print";
import {
    Box,
    Button,
    Chip,
    CircularProgress,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Menu,
    MenuItem,
    Snackbar,
    Stack,
    Step,
    StepLabel,
    Stepper,
    Tab,
    Tabs,
    TextField,
    Typography,
    useMediaQuery,
} from "@mui/material";
import Collapse from "@mui/material/Collapse";
import copy from "copy-to-clipboard";
import { ClientPrintJob, InstalledPrinter, JSPrintManager, WSStatus } from "jsprintmanager";
import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { ToastContainer, toast } from "react-toast";
import Copyright from "../Copyright";
import httpRequest from "../HttpService";
import { useUserContext } from "../lib/user_context";
import Gallery from "../newOrder/components/gallery";
import { getStatusString } from "../newOrder/components/helperFunctions/index.js";
import SelectInput from "../newOrder/components/inputFields/SelectInput_org";
import PrintPanel from "../newOrder/components/printPanel";
import MapboxPanel from "./components/MapboxPanel/index";
import OrderReceiptPanel from "./components/OrderReceiptPanel.js";
import TagsPanel from "./components/TagsPanel.js";
import Carousel from "./components/carouselPanel";
import ImageViewer from "./components/imageViewer.js";
import BillsList from "./components/orderDetailBillingList.js";
import PageBanner from "./components/pageBanner";
import Panel from "./components/whitePanel";
import "./orderDetail.css";

export default function OrderDetail(props) {
    const { orderID } = useParams();
    const { account } = useParams();
    const [order, setOrder] = useState({});
    const [activeStep, setActiveStep] = useState(0);
    const [showDeliveryDetails, setShowDeliveryDetails] = useState(false);
    const [photoArray, setPhotoArray] = useState([]);
    const [steps, setSteps] = useState([]);
    const [bills, setBills] = useState([]);
    const [openMessageBox, setOpenMessageBox] = useState(false);
    const [openCallMeBox, setOpenCallMeBox] = useState(false);
    const [message, setMessage] = useState("");
    const [phone, setPhone] = useState({ phoneNumber: "", ext: "" });
    const [selectedPrinter, setSelectedPrinter] = useState(null);
    const [printsList, setPrintsList] = useState([]);
    const [isPrint, setIsPrint] = useState(false);
    const [intervalId, setIntervalId] = useState(0);
    const [tabValue, setTabValue] = useState(0);
    const [isUploadFile, setIsUploadFile] = useState(false);
    const [isPrintReceipt, setIsPrintReceipt] = useState(false);
    const [isPrintSummary, setIsPrintSummary] = useState(false);
    const [printMenuAnchor, setPrintMenuAnchor] = useState(null);
    const [copySnack, setCopySnack] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const { sessionPreference } = useUserContext();
    const companyLogo =
        Number(sessionPreference?.companyID) === 5
            ? "https://directitsqlblob.blob.core.windows.net/images/email/argus.png"
            : order.brandLogoURL?.trim()
              ? order.brandLogoURL
              : null;
    const isMobile = useMediaQuery("(max-width:768px)");

    const componentRef = useRef();
    const receiptPrintRef = useRef();
    const summaryPrintRef = useRef();

    const getFileUrl = (url) => {
        if (!url) return "";
        return `https://drive.google.com/viewerng/viewer?embedded=true&url=${url}#toolbar=0&scrollbar=0`;
    };

    const getOrder = useCallback(async () => {
        try {
            getPhotos();
            httpRequest.getOrder(account, orderID).then((response) => {
                console.log("useEffect getOrder--" + JSON.stringify(response.data));
                var _order = response.data;
                let extraInfo = {};
                if (_order.extraInfoJSON) {
                    try {
                        extraInfo = JSON.parse(_order.extraInfoJSON);
                    } catch (e) {}
                }
                _order.extraInfo = extraInfo;
                _order.dtDelivered_display = formatDateForTimezone(_order.dtoDelivered, _order.timezone);
                _order.dtCallIn_display = formatDateForTimezone(_order.dtoCreated, _order.timezone);
                _order.dtDCT_display = formatDateForTimezone(_order.dtoDeliverBy, _order.timezone);
                _order.dtPicked_display = formatDateForTimezone(_order.dtoPicked, _order.timezone);

                _order.del_inTime_display = extraInfo.del_inTime
                    ? extraInfo.del_inTime.substring(0, 19).replace("T", " ")
                    : "";
                _order.pick_inTime_display = extraInfo.pick_inTime
                    ? extraInfo.pick_inTime.substring(0, 19).replace("T", " ")
                    : "";

                setOrder(_order);
                setIsLoading(false);

                httpRequest.getOrderDetailBilling(orderID).then((response) => {
                    console.log("getOrderDetailBilling--" + JSON.stringify(response.data));
                    var bList = response.data.map((option, index) => {
                        return {
                            ...option,
                            id: index,
                        };
                    });
                    setBills(bList);
                });

                getOrderTrack();
                if (_order.Status < 8) {
                    const newIntervalId = setInterval(() => {
                        getPhotos();
                        httpRequest.getOrder(account, orderID).then((response) => {
                            var _order = response.data;
                            let extraInfo = {};
                            if (_order.extraInfoJSON) {
                                try {
                                    extraInfo = JSON.parse(_order.extraInfoJSON);
                                } catch (e) {}
                            }
                            _order.extraInfo = extraInfo;
                            _order.dtDelivered_display = formatDateForTimezone(_order.dtoDelivered, _order.timezone);
                            _order.dtCallIn_display = formatDateForTimezone(_order.dtoCreated, _order.timezone);
                            _order.dtDCT_display = formatDateForTimezone(_order.dtoDeliverBy, _order.timezone);
                            _order.dtPicked_display = formatDateForTimezone(_order.dtoPicked, _order.timezone);

                            _order.del_inTime_display = extraInfo.del_inTime
                                ? extraInfo.del_inTime.substring(0, 19).replace("T", " ")
                                : "";
                            _order.pick_inTime_display = extraInfo.pick_inTime
                                ? extraInfo.pick_inTime.substring(0, 19).replace("T", " ")
                                : "";

                            setOrder(_order);
                            getOrderTrack();
                            if (_order.Status >= 8) clearInterval(intervalId);
                        });
                    }, 60000);
                    return () => {
                        clearInterval(newIntervalId);
                    };
                }
            });
        } catch (error) {
            console.log(error);
        }

        try {
            JSPrintManager.auto_reconnect = false;
            JSPrintManager.start();
            var printListStr = localStorage.getItem("PrintList");
            if (printListStr && printListStr !== "") {
                let printers = JSON.parse(printListStr);
                setPrintsList(printers);
                var defaultPrinter = printers.find(function (obj) {
                    return obj.label.includes("ZPL");
                });
                if (defaultPrinter === undefined) setSelectedPrinter(printers[0]?.label);
                else {
                    var index = printers.findIndex((x) => x.label === defaultPrinter.label);
                    setSelectedPrinter(printers[index].label);
                }
                console.log("order detail defaultPrinter :" + selectedPrinter);
            }
            JSPrintManager.WS.onStatusChanged = () => {
                if (JSPrintManager.websocket_status === WSStatus.Open) {
                }
            };
            JSPrintManager.WS.onError = (err) => {
                console.log("JSPrintManager not available - printing features disabled");
            };
        } catch (e) {
            console.log("JSPrintManager not installed - printing features will be limited:", e.message);
        }
    }, []);

    useEffect(() => {
        getOrder();
    }, [orderID, account]);

    const allyProps = (index) => {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
        };
    };

    const getOrderTrack = () => {
        httpRequest.getOrderTrack(orderID).then((response) => {
            var tempTrackList = response.data.map((option, index) => {
                return {
                    ...option,
                    id: index,
                };
            });
            setSteps(tempTrackList);
            const firstUnfilled = tempTrackList.findIndex((step) => !step.filled);
            setActiveStep(firstUnfilled === -1 ? tempTrackList.length : firstUnfilled);
        });
    };

    // const getPhotos = () => {
    //     httpRequest.getPhotoURLs(orderID).then((response) => {
    //       var imageList = [];
    //       response.data.forEach((value) => {
    //         value.savedTimeUTC = moment(value.savedTimeUTC).format("YY-MM-DD HH:mm");
    //         value.id = imageList.length;
    //         value.imageType = value.url.endsWith("png") || value.url.endsWith("jpg") || value.url.endsWith("bmp") ? "image" : "file";
    //         value.fileType = value.url.endsWith("png") || value.url.endsWith("jpg") || value.url.endsWith("bmp") ? "image" : value.url.substring(value.url.length - 3);
    //         value.fileExt = value.url.substring(value.url.length - 3);
    //         if (value.imageType === "image") imageList.push(value);
    //       });
    //       setPhotoArray(imageList);
    //       setIsUploadFile(false);
    //     });
    // };

    const getPhotos = () => {
        httpRequest.getPhotoURLs(orderID).then((response) => {
            //console.log("getPhotoURLs--" + JSON.stringify(response.data));
            let imageList = response.data.map((value, i) => {
                value.savedTimeUTC = moment(value.savedTimeUTC).format("YY-MM-DD HH:mm");
                value.id = i;
                value.imageType =
                    value.url.endsWith("png") || value.url.endsWith("jpg") || value.url.endsWith("bmp")
                        ? "image"
                        : "file";
                value.fileType =
                    value.url.endsWith("png") || value.url.endsWith("jpg") || value.url.endsWith("bmp")
                        ? "image"
                        : value.url.substring(value.url.length - 3);
                value.fileExt = value.url.substring(value.url.length - 3);
                if (
                    value.fileExt === "pdf" ||
                    value.fileExt === "doc" ||
                    value.fileExt === "docx" ||
                    value.fileExt === "xls" ||
                    value.fileExt === "xlsx" ||
                    value.fileExt === "csv"
                ) {
                    var file_url = getFileUrl(value.url);
                    value.file_url = file_url;
                }
                return value;
            });
            setPhotoArray(imageList);
            setIsUploadFile(false);
        });
    };

    const tzMap = {
        "Pacific Standard Time": "America/Los_Angeles",
        "Mountain Standard Time": "America/Edmonton",
        "Central Standard Time": "America/Chicago",
        "Eastern Standard Time": "America/New_York",
        "Atlantic Standard Time": "America/Halifax",
        "Newfoundland Standard Time": "America/St_Johns",
    };

    const formatDateForTimezone = (utcDateStr, tz) => {
        if (!utcDateStr) return "";
        try {
            const ianaZone = tzMap[tz];
            if (!ianaZone) return utcDateStr.substring(0, 19).replace("T", " ");
            const d = new Date(utcDateStr);
            return d.toLocaleString("sv-SE", {
                timeZone: ianaZone,
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
            });
        } catch (e) {
            return utcDateStr.substring(0, 19).replace("T", " ");
        }
    };

    const formatOrderTime = (utcTimestamp) => {
        const d = new Date(utcTimestamp);
        const ianaZone = tzMap[order.timezone];
        if (!ianaZone) return `${moment.utc(utcTimestamp).format("MM-DD")} @ ${moment.utc(utcTimestamp).format("LT")}`;
        const opts = { timeZone: ianaZone };
        const dateStr = d.toLocaleDateString("en-US", {
            ...opts,
            month: "2-digit",
            day: "2-digit",
        });
        const timeStr = d.toLocaleTimeString("en-US", {
            ...opts,
            hour: "numeric",
            minute: "2-digit",
        });
        const localZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (ianaZone !== localZone) {
            const tzAbbr = d
                .toLocaleTimeString("en-US", { ...opts, timeZoneName: "short" })
                .split(" ")
                .pop();
            return `${dateStr} @ ${timeStr} ${tzAbbr}`;
        }
        return `${dateStr} @ ${timeStr}`;
    };

    const renderStepContentText = (label) => {
        return (
            <div>
                <Typography>{label.bigText}</Typography>
                <Typography variant="caption">{label.smallText + formatOrderTime(label.timestamp_utc)}</Typography>
                {label.img_url && (
                    <span>
                        <a href={label.img_http_link} target="_blank" rel="noopener noreferrer">
                            {label.img_text}
                        </a>
                        <div>
                            <img
                                style={{ width: "80px", height: "60px" }}
                                src={label.img_url}
                                onClick={() => {
                                    window.open(label.img_http_link, "_blank");
                                }}
                                alt="Step content"
                            />
                        </div>
                    </span>
                )}
            </div>
        );
    };

    const renderFromAddress = () => {
        const suite = order.sSuite ? order.sSuite + ", " : "";
        return (
            <>
                {`${suite}${order.sAddress} ${order.sQuad}`.trim()}
                <br />
                {`${order.sCity}, ${order.sProv}, ${order.sPostal}, ${order.sCountry}`}
            </>
        );
    };

    const renderToAddress = () => {
        const suite = order.cSuite ? order.cSuite + ", " : "";
        return (
            <>
                {`${suite}${order.cAddress} ${order.cQuad}`.trim()}
                <br />
                {`${order.cCity}, ${order.cProv}, ${order.cPostal}, ${order.cCountry}`}
            </>
        );
    };

    const handleTabChange = (_event, newValue) => {
        setTabValue(newValue);
        if (newValue === 0 && isUploadFile) {
            getPhotos();
        }
    };

    const handlePrintChange = (event) => {
        try {
            const { value } = event.target;
            setSelectedPrinter(printsList[parseInt(value)].label);
            console.log("selectedPrinter---", selectedPrinter);
        } catch (err) {
            console.log("handlePrintChange exception:" + err);
        }
    };

    const zplPrint = () => {
        if (JSPrintManager.websocket_status === WSStatus.Open) {
            httpRequest.getLabelString(order.jobID).then(async (body) => {
                //console.log("getZPLLabel return-" + JSON.stringify(body.data));
                var zplLabel = body.data;
                var cpj = new ClientPrintJob();
                cpj.clientPrinter = new InstalledPrinter(selectedPrinter);
                cpj.printerCommands = zplLabel.ZPLString;
                cpj.sendToClient();
            });
        } else {
            toast("Failed to print label, please check print connection!");
        }
    };

    const messageSubmit = () => {
        var msg = {
            userName: " ",
            userEmail: " ",
            messageText: message,
            jobID: orderID,
        };
        httpRequest.sendWebMessage(account, msg).then((response) => {
            setOpenMessageBox(false);
            toast("You will see requested changes to a trip here within the next 5 minutes");
        });
    };

    const callMeSubmit = () => {
        if (order.PROOF_DEL) {
            setOpenCallMeBox(false);
            return;
        }
        var phoneNum = phone.ext === "" ? phone.phoneNumber : phone.phoneNumber + "-" + phone.ext;
        toast("submit phone number:" + phoneNum);
        setOpenCallMeBox(false);
        httpRequest
            .callMe(account, orderID, phoneNum)
            .then((response) => {
                toast("We will call you in the next 5 minutes (M-F 7:30am - 4:30pm)");
            })
            .catch((err) => {
                toast("Failed to add Job Phone Number" + err);
            });
    };

    const handlePrint = useReactToPrint({
        contentRef: componentRef,
        onAfterPrint: () => {
            setIsPrint(false);
        },
    });

    const doPrintReceipt = useReactToPrint({
        contentRef: receiptPrintRef,
        onAfterPrint: () => {
            setIsPrintReceipt(false);
        },
    });

    const doPrintSummary = useReactToPrint({
        contentRef: summaryPrintRef,
        onAfterPrint: () => {
            setIsPrintSummary(false);
        },
    });

    const handleClick = () => {
        setShowDeliveryDetails(!showDeliveryDetails);
    };

    // ── Helper components ──────────────────────────────────────────────────────

    const DetailField = ({ label, value }) => (
        <Grid item xs={12} sm={6} md={4}>
            <Typography
                variant="caption"
                sx={{
                    display: "block",
                    textTransform: "uppercase",
                    letterSpacing: "0.7px",
                    color: "text.disabled",
                    fontWeight: 700,
                    fontSize: "0.62rem",
                    mb: 0.5,
                }}
            >
                {label}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.primary", fontWeight: 500, lineHeight: 1.4 }}>
                {value || <span style={{ color: "#ccc" }}>—</span>}
            </Typography>
        </Grid>
    );

    const DetailGroup = ({ title, children }) => (
        <Box>
            <Typography
                variant="overline"
                sx={{
                    display: "block",
                    color: "text.disabled",
                    fontWeight: 700,
                    letterSpacing: "0.08em",
                    fontSize: "0.65rem",
                    mb: 1.5,
                }}
            >
                {title}
            </Typography>
            <Grid container rowSpacing={2} columnSpacing={3}>
                {children}
            </Grid>
        </Box>
    );

    const StatItem = ({ label, value }) => (
        <Box sx={{ flex: 1, minWidth: 0, px: { xs: 0, sm: 1 } }}>
            <Typography
                variant="caption"
                sx={{
                    display: "block",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    color: "text.secondary",
                    fontWeight: 600,
                    mb: 0.5,
                }}
            >
                {label}
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 600, color: "text.primary" }}>
                {value || <span style={{ color: "#bbb" }}>—</span>}
            </Typography>
        </Box>
    );

    const isDelivered = order.Status >= 8;
    const statusColor = isDelivered ? "success.main" : "primary.main";

    // ── renderDeliveryDetails ──────────────────────────────────────────────────

    const renderDeliveryDetails = () => {
        const tz = order.timezone ? " " + order.timezone : "";
        return (
            <Stack spacing={2.5}>
                <DetailGroup title="Order Info">
                    <DetailField label="Caller" value={order.CALLER} />
                    <DetailField label="Call In" value={order.dtCallIn_display ? order.dtCallIn_display + tz : ""} />
                    <DetailField label="Service Minutes" value={order.SER_TIME} />
                    <DetailField label="Rate (Before Tax)" value={order.RATE ? `$${order.RATE}` : ""} />
                </DetailGroup>

                <Divider />

                <DetailGroup title="Pickup">
                    <DetailField
                        label="Driver In"
                        value={order.pick_inTime_display ? order.pick_inTime_display + tz : ""}
                    />
                    <DetailField label="Driver Out" value={order.dtPicked_display ? order.dtPicked_display + tz : ""} />
                    <DetailField label="Time Spent" value={order.extraInfo?.pick_timeSpent} />
                </DetailGroup>

                <Divider />

                <DetailGroup title="Delivery">
                    <DetailField
                        label="Driver In"
                        value={order.del_inTime_display ? order.del_inTime_display + tz : ""}
                    />
                    <DetailField
                        label="Driver Out"
                        value={order.dtDelivered_display ? order.dtDelivered_display + tz : ""}
                    />
                    <DetailField label="Time Spent" value={order.extraInfo?.del_timeSpent} />
                </DetailGroup>

                <Divider />

                <Box>
                    <Typography
                        variant="overline"
                        sx={{
                            display: "block",
                            color: "text.disabled",
                            fontWeight: 700,
                            letterSpacing: "0.08em",
                            fontSize: "0.65rem",
                            mb: 1.5,
                        }}
                    >
                        Bills
                    </Typography>
                    <BillsList bills={bills} />
                </Box>
            </Stack>
        );
    };

    // ── Render ─────────────────────────────────────────────────────────────────

    return (
        <Box className="NewOrder">
            <PageBanner title="JOB STATUS" subheading={"#" + orderID} />
            <Container maxWidth="lg">
                <div id="pageContent" style={{ marginTop: "-48px" }}>
                    {isLoading ? (
                        <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
                            <CircularProgress />
                        </Box>
                    ) : isPrint ? (
                        <Panel>
                            {printsList && printsList.length > 0 && (
                                <SelectInput
                                    optionList={printsList}
                                    value={selectedPrinter?.value}
                                    name="selectPrinter"
                                    onChange={handlePrintChange}
                                    label="Printer"
                                />
                            )}
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    setIsPrint(false);
                                }}
                                style={{ float: "right", margin: "2px" }}
                            >
                                Cancel
                            </Button>
                            {selectedPrinter && selectedPrinter.includes("ZPL") ? (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={zplPrint}
                                    style={{ float: "left", margin: "2px" }}
                                >
                                    Print
                                </Button>
                            ) : (
                                <Button variant="contained" color="primary" onClick={handlePrint}>
                                    Print
                                </Button>
                            )}
                            <div ref={componentRef}>
                                <PrintPanel id={orderID} account={order.ACCOUNT} logoUrl={companyLogo} />
                            </div>
                        </Panel>
                    ) : isPrintReceipt ? (
                        <Panel>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => setIsPrintReceipt(false)}
                                style={{ float: "right", margin: "2px" }}
                            >
                                Back
                            </Button>
                            <div ref={receiptPrintRef}>
                                <OrderReceiptPanel
                                    orderID={order.jobID}
                                    order={order}
                                    doPrintReceipt={doPrintReceipt}
                                    logoUrl={companyLogo}
                                    bills={bills}
                                />
                            </div>
                        </Panel>
                    ) : isPrintSummary ? (
                        <Panel>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => setIsPrintSummary(false)}
                                style={{ float: "right", margin: "2px" }}
                            >
                                Back
                            </Button>
                            <div ref={summaryPrintRef}>
                                <OrderReceiptPanel
                                    orderID={order.jobID}
                                    order={order}
                                    doPrintReceipt={doPrintSummary}
                                    logoUrl={companyLogo}
                                />
                            </div>
                        </Panel>
                    ) : (
                        <Stack spacing={2} sx={{ pb: 4 }}>
                            {/* === STATUS HERO === */}
                            <Panel>
                                <Grid container spacing={3} alignItems="center">
                                    <Grid item xs={12} lg={3}>
                                        <Stack
                                            spacing={1.5}
                                            sx={{
                                                borderRight: { lg: "1px solid" },
                                                borderBottom: { xs: "1px solid", lg: "none" },
                                                borderColor: { xs: "divider", lg: "divider" },
                                                pr: { lg: 3 },
                                                pb: { xs: 2, lg: 0 },
                                            }}
                                        >
                                            <Box>
                                                <Typography
                                                    variant="caption"
                                                    sx={{
                                                        display: "block",
                                                        textTransform: "uppercase",
                                                        letterSpacing: "0.5px",
                                                        color: "text.secondary",
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    Status
                                                </Typography>
                                                <Typography
                                                    variant="h5"
                                                    sx={{ fontWeight: 700, color: statusColor, mt: 0.5 }}
                                                >
                                                    {getStatusString(order.Status) || "—"}
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Typography
                                                    variant="caption"
                                                    sx={{
                                                        display: "block",
                                                        textTransform: "uppercase",
                                                        letterSpacing: "0.5px",
                                                        color: "text.secondary",
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    Job ID
                                                </Typography>
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        fontWeight: 600,
                                                        fontFamily: "monospace",
                                                        mt: 0.25,
                                                    }}
                                                >
                                                    {orderID}
                                                </Typography>
                                            </Box>
                                            {order.TrackNumber && (
                                                <Box>
                                                    <Typography
                                                        variant="caption"
                                                        sx={{
                                                            display: "block",
                                                            textTransform: "uppercase",
                                                            letterSpacing: "0.5px",
                                                            color: "text.secondary",
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        Tracking Number
                                                    </Typography>
                                                    <Stack
                                                        direction="row"
                                                        alignItems="center"
                                                        spacing={0.5}
                                                        sx={{ mt: 0.25 }}
                                                    >
                                                        <Typography
                                                            variant="body1"
                                                            sx={{
                                                                fontWeight: 600,
                                                                fontFamily: "monospace",
                                                                letterSpacing: "0.5px",
                                                            }}
                                                        >
                                                            {order.TrackNumber}
                                                        </Typography>
                                                        <IconButton
                                                            size="small"
                                                            aria-label="copy tracking link"
                                                            onClick={() => {
                                                                copy(
                                                                    "https://tracking.directx.ca/trackNo/" +
                                                                        order.TrackNumber
                                                                );
                                                                setCopySnack(true);
                                                            }}
                                                        >
                                                            <CopyIcon fontSize="small" color="primary" />
                                                        </IconButton>
                                                    </Stack>
                                                </Box>
                                            )}
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={12} lg={9}>
                                        <Stepper
                                            activeStep={activeStep}
                                            alternativeLabel={!isMobile}
                                            orientation={isMobile ? "vertical" : "horizontal"}
                                        >
                                            {steps.map((label) => (
                                                <Step key={label.bigText} completed={label.filled}>
                                                    <StepLabel>{renderStepContentText(label)}</StepLabel>
                                                </Step>
                                            ))}
                                        </Stepper>
                                    </Grid>
                                </Grid>
                            </Panel>

                            {/* === ROUTE PANEL === */}
                            <Panel>
                                {/* Action buttons row */}
                                <Stack direction="row" justifyContent="flex-end" flexWrap="wrap" gap={1} sx={{ mb: 2 }}>
                                    {/* Communication buttons */}
                                    {props.variant === "orderStatus" && (
                                        <Stack direction="row" gap={1}>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                size="small"
                                                startIcon={<MailIcon />}
                                                onClick={() => setOpenMessageBox(true)}
                                                sx={{
                                                    minWidth: "auto",
                                                    px: { xs: "8px", sm: "15px" },
                                                    "& .MuiButton-startIcon": { mr: { xs: 0, sm: 0.75 } },
                                                }}
                                                title="Send Message"
                                            >
                                                <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
                                                    Send Message
                                                </Box>
                                            </Button>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                size="small"
                                                startIcon={<PhoneIcon />}
                                                onClick={() => setOpenCallMeBox(true)}
                                                sx={{
                                                    minWidth: "auto",
                                                    px: { xs: "8px", sm: "15px" },
                                                    "& .MuiButton-startIcon": { mr: { xs: 0, sm: 0.75 } },
                                                }}
                                                title="Call Me"
                                            >
                                                <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
                                                    Call Me
                                                </Box>
                                            </Button>
                                        </Stack>
                                    )}
                                    {/* Print dropdown */}
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        startIcon={<PrintIcon />}
                                        endIcon={<ArrowDropDownIcon />}
                                        onClick={(e) => setPrintMenuAnchor(e.currentTarget)}
                                        sx={{
                                            minWidth: "auto",
                                            px: { xs: "8px", sm: "15px" },
                                            "& .MuiButton-startIcon": { mr: { xs: 0, sm: 0.75 } },
                                        }}
                                    >
                                        <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
                                            Print
                                        </Box>
                                    </Button>
                                    <Menu
                                        anchorEl={printMenuAnchor}
                                        open={Boolean(printMenuAnchor)}
                                        onClose={() => setPrintMenuAnchor(null)}
                                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                                    >
                                        <MenuItem
                                            onClick={() => {
                                                setPrintMenuAnchor(null);
                                                setIsPrint(true);
                                            }}
                                        >
                                            Reprint Label
                                        </MenuItem>
                                        {props.variant === "orderStatus" && (
                                            <MenuItem
                                                onClick={() => {
                                                    setPrintMenuAnchor(null);
                                                    setIsPrintReceipt(true);
                                                }}
                                            >
                                                Print Receipt
                                            </MenuItem>
                                        )}
                                        {props.variant === "orderStatus" && (
                                            <MenuItem
                                                onClick={() => {
                                                    setPrintMenuAnchor(null);
                                                    setIsPrintSummary(true);
                                                }}
                                            >
                                                Print Summary
                                            </MenuItem>
                                        )}
                                    </Menu>
                                </Stack>

                                {/* Logo + From → To addresses at same level */}
                                <Box
                                    sx={{
                                        display: "grid",
                                        gridTemplateColumns: "25% 1fr auto 1fr",
                                        alignItems: "center",
                                        gap: 2,
                                    }}
                                >
                                    <Box>
                                        <img
                                            src={order.brandLogoURL?.trim() ? order.brandLogoURL : companyLogo}
                                            alt="Company Logo"
                                            style={{ width: "100%", height: "auto", display: "block" }}
                                        />
                                    </Box>
                                    <Stack direction="row" spacing={1.5} alignItems="flex-start">
                                        <LocationOnIcon sx={{ color: "text.secondary", mt: 0.25 }} fontSize="small" />
                                        <Box sx={{ minWidth: 0, flex: 1 }}>
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    display: "block",
                                                    textTransform: "uppercase",
                                                    letterSpacing: "0.5px",
                                                    color: "text.secondary",
                                                    fontWeight: 600,
                                                }}
                                            >
                                                From
                                            </Typography>
                                            <Typography
                                                variant="subtitle1"
                                                sx={{ fontWeight: 700, lineHeight: 1.3, mt: 0.25 }}
                                            >
                                                {order.sCompanyName || "—"}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {renderFromAddress()}
                                            </Typography>
                                        </Box>
                                    </Stack>
                                    <ArrowForwardIcon sx={{ color: "text.disabled" }} fontSize="small" />
                                    <Stack direction="row" spacing={1.5} alignItems="flex-start">
                                        <LocationOnIcon sx={{ color: "primary.main", mt: 0.25 }} fontSize="small" />
                                        <Box sx={{ minWidth: 0, flex: 1 }}>
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    display: "block",
                                                    textTransform: "uppercase",
                                                    letterSpacing: "0.5px",
                                                    color: "text.secondary",
                                                    fontWeight: 600,
                                                }}
                                            >
                                                To
                                            </Typography>
                                            <Typography
                                                variant="subtitle1"
                                                sx={{ fontWeight: 700, lineHeight: 1.3, mt: 0.25 }}
                                            >
                                                {order.cCompanyName || "—"}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {renderToAddress()}
                                            </Typography>
                                        </Box>
                                    </Stack>
                                </Box>

                                <Divider sx={{ my: 2.5 }} />

                                {/* Package stats */}
                                <Stack
                                    direction={{ xs: "column", sm: "row" }}
                                    spacing={{ xs: 1.5, sm: 0 }}
                                    divider={
                                        <Divider
                                            orientation="vertical"
                                            flexItem
                                            sx={{ display: { xs: "none", sm: "block" } }}
                                        />
                                    }
                                    sx={{ mb: order.DEL_INST ? 2 : 0 }}
                                >
                                    <StatItem label="Pieces" value={order.PIECES} />
                                    <StatItem label="Weight" value={order.WEIGHT} />
                                    {(order.DimsString || order.dimsString) && (
                                        <StatItem label="Dims" value={order.DimsString || order.dimsString} />
                                    )}
                                    <StatItem label="Service" value={order.serviceText} />
                                    <StatItem
                                        label={isDelivered ? "Delivered At" : "Due By"}
                                        value={
                                            (isDelivered ? order.dtDelivered_display : order.dtDCT_display)
                                                ? (isDelivered ? order.dtDelivered_display : order.dtDCT_display) +
                                                  " " +
                                                  (order.timezone || "")
                                                : ""
                                        }
                                    />
                                </Stack>

                                {/* {order.DEL_INST && (
                                    <Box
                                        sx={{
                                            bgcolor: "rgba(51, 122, 183, 0.06)",
                                            borderLeft: "3px solid",
                                            borderColor: "primary.main",
                                            p: 1.5,
                                            borderRadius: "0 4px 4px 0",
                                        }}
                                    >
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                display: "block",
                                                textTransform: "uppercase",
                                                letterSpacing: "0.5px",
                                                color: "primary.main",
                                                fontWeight: 600,
                                                mb: 0.25,
                                            }}
                                        >
                                            Instructions
                                        </Typography>
                                        <Typography variant="body2">{order.DEL_INST}</Typography>
                                    </Box>
                                )} */}

                                <TagsPanel tagIcons={order.tagIcons} />
                            </Panel>

                            {/* === PROOF OF DELIVERY === */}
                            {isDelivered && (
                                <Panel>
                                    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                textTransform: "uppercase",
                                                letterSpacing: "0.5px",
                                                color: "text.secondary",
                                                fontWeight: 600,
                                            }}
                                        >
                                            Proof of Delivery
                                        </Typography>
                                        {getStatusString(order.Status) && (
                                            <Chip
                                                label={getStatusString(order.Status)}
                                                size="small"
                                                color="success"
                                                variant="outlined"
                                                sx={{ height: 20, fontSize: "0.7rem" }}
                                            />
                                        )}
                                    </Stack>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={5}>
                                            {order.signatureURL ? (
                                                <Box
                                                    sx={{
                                                        p: 2,
                                                        border: "1px solid",
                                                        borderColor: "divider",
                                                        borderRadius: 1,
                                                        bgcolor: "#fafafa",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <img
                                                        src={order.signatureURL}
                                                        alt="Customer Signature"
                                                        style={{
                                                            display: "block",
                                                            width: "100%",
                                                            maxWidth: 320,
                                                            margin: "0 auto",
                                                        }}
                                                    />
                                                    <Typography
                                                        variant="caption"
                                                        color="text.secondary"
                                                        sx={{ display: "block", mt: 1 }}
                                                    >
                                                        Signature on file
                                                    </Typography>
                                                </Box>
                                            ) : (
                                                <Box
                                                    sx={{
                                                        p: 2,
                                                        border: "1px dashed",
                                                        borderColor: "divider",
                                                        borderRadius: 1,
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <Typography variant="body2" color="text.secondary">
                                                        No signature captured
                                                    </Typography>
                                                </Box>
                                            )}
                                        </Grid>
                                        <Grid item xs={12} md={7}>
                                            <Grid container rowSpacing={2} columnSpacing={3}>
                                                <DetailField label="Signed By" value={order.PROOF_DEL} />
                                                <DetailField
                                                    label="Delivered"
                                                    value={
                                                        order.dtDelivered_display
                                                            ? order.dtDelivered_display + " " + (order.timezone || "")
                                                            : ""
                                                    }
                                                />
                                                <DetailField label="Billing Reference" value={order.CUST_REF} />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Panel>
                            )}

                            {/* === ADDITIONAL DETAILS (collapsible) === */}
                            <Panel>
                                <Box
                                    onClick={handleClick}
                                    sx={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        userSelect: "none",
                                    }}
                                >
                                    <Typography
                                        variant="caption"
                                        sx={{
                                            textTransform: "uppercase",
                                            letterSpacing: "0.5px",
                                            color: "text.secondary",
                                            fontWeight: 600,
                                        }}
                                    >
                                        Additional Details
                                    </Typography>
                                    {showDeliveryDetails ? (
                                        <ExpandLess color="primary" />
                                    ) : (
                                        <ExpandMore color="primary" />
                                    )}
                                </Box>
                                <Collapse in={showDeliveryDetails} timeout="auto" unmountOnExit>
                                    <Box
                                        sx={{
                                            mt: 2,
                                            pt: 2,
                                            borderTop: "1px solid",
                                            borderColor: "divider",
                                        }}
                                    >
                                        {renderDeliveryDetails()}
                                    </Box>
                                </Collapse>
                            </Panel>

                            {/* === MAP + IMAGES === */}
                            <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                                <Box sx={{ flex: 7, minWidth: 0 }}>
                                    <Panel sx={{ m: 0 }}>
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                display: "block",
                                                textTransform: "uppercase",
                                                letterSpacing: "0.5px",
                                                color: "text.secondary",
                                                fontWeight: 600,
                                                mb: 1.5,
                                            }}
                                        >
                                            Live Tracking
                                        </Typography>
                                        {order.jobID && (
                                            <MapboxPanel orderID={order.jobID} order={order} photoList={photoArray} />
                                        )}
                                    </Panel>
                                </Box>
                                <Box sx={{ flex: 5, minWidth: 0 }}>
                                    <Panel sx={{ m: 0 }}>
                                        <Tabs value={tabValue} onChange={handleTabChange} aria-label="tabs">
                                            <Tab label="Attached Picture" {...allyProps(0)} />
                                            {!isDelivered && <Tab label="Add Files" {...allyProps(1)} />}
                                        </Tabs>
                                        {tabValue === 0 && (
                                            <Carousel
                                                show={photoArray.length !== 0 ? true : false}
                                                numOfImages={photoArray.length}
                                            >
                                                {photoArray.map((image, i) => (
                                                    <div
                                                        key={i}
                                                        style={{
                                                            justifyContent: "center",
                                                            height: "50%",
                                                            verticalAlign: "middle",
                                                            display: "flex",
                                                        }}
                                                    >
                                                        {image.imageType === "image" ? (
                                                            <ImageViewer src={image.url} />
                                                        ) : (
                                                            <iframe
                                                                src={image.file_url}
                                                                height="420px"
                                                                width="80%"
                                                                title={`file-${i}`}
                                                            ></iframe>
                                                        )}
                                                    </div>
                                                ))}
                                            </Carousel>
                                        )}
                                        {tabValue === 1 && !isDelivered && (
                                            <div>
                                                <Gallery
                                                    jobId={orderID}
                                                    setUploadFileFlag={() => {
                                                        setIsUploadFile(true);
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </Panel>
                                </Box>
                            </Stack>
                        </Stack>
                    )}
                </div>

                <Dialog
                    open={openMessageBox}
                    onClose={() => {
                        setOpenMessageBox(false);
                    }}
                >
                    <DialogTitle>Send Message about the Trip</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            name="message"
                            label="Message"
                            type="text"
                            fullWidth
                            variant="standard"
                            onChange={(event) => {
                                setMessage(event.target.value);
                            }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                setOpenMessageBox(false);
                            }}
                        >
                            Cancel
                        </Button>
                        <Button onClick={messageSubmit}>Submit</Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={openCallMeBox}
                    onClose={() => {
                        setOpenCallMeBox(false);
                    }}
                >
                    <DialogTitle>Call Request</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            name="phone"
                            label="Phone Number"
                            type="number"
                            fullWidth
                            variant="standard"
                            onChange={(event) => {
                                setPhone((prevState) => {
                                    return { ...prevState, phoneNumber: event.target.value };
                                });
                            }}
                        />
                        <TextField
                            margin="dense"
                            name="ext"
                            label="Ext"
                            type="number"
                            fullWidth
                            variant="standard"
                            onChange={(event) => {
                                setPhone((prevState) => {
                                    return { ...prevState, ext: event.target.value };
                                });
                            }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                setOpenCallMeBox(false);
                            }}
                        >
                            Cancel
                        </Button>
                        <Button onClick={callMeSubmit}>Submit</Button>
                    </DialogActions>
                </Dialog>

                <ToastContainer />
                <Snackbar
                    open={copySnack}
                    onClose={() => setCopySnack(false)}
                    autoHideDuration={2000}
                    message="Tracking URL copied to clipboard"
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                />
                {props.isEmbedded !== null && props.isEmbedded !== "yes" && (
                    <footer>
                        <Copyright />
                    </footer>
                )}
            </Container>
        </Box>
    );
}
